<template>
  <div
    class="KoioteValueLabel"
    :style="valueLabelStyle"
    @click="showHistoryDialog = true"
  >
    {{ label }}{{ value }}{{ this.input.customized.units }}
    <v-dialog
      v-if="!editing && this.variable?.seconds > 0"
      v-model="showHistoryDialog"
    >
      <template>
        <v-container fluid>
          <MultiVariableLineChart
            :title="`Evolución en tiempo real de ${label.substring(0, label.length - 2)}`"
            realTime
            :address="this.input.customized.address"
            @close="showHistoryDialog = false"
          ></MultiVariableLineChart>
        </v-container>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import MultiVariableLineChart from "@/components/utils/MultiVariableLineChart.vue";

export default {
  name: "KoioteValueLabel",

  components: { MultiVariableLineChart },

  props: {
    input: Object,
  },

  data() {
    return {
      showHistoryDialog: false,
    };
  },

  computed: {
    ...mapState(["editing"]),

    valueLabelStyle() {
      return {
        backgroundColor: this.input.customized.background_color,
        color: this.input.customized.foreground_color,
        border: "1px solid " + this.input.customized.border_color,
        width: "100%",
        height: "100%",
        position: "absolute",
        alignContent: "center",
        textAlign: "center",
        whiteSpace: "break-spaces",
        lineHeight: "normal",
      };
    },

    label() {
      return this.input.customized?.label?.length > 0 ? `${this.input.customized.label}: ` : "";
    },

    variable() {
      return this.actualPage()
        .global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        .customized.vartable.find((v) => v.formatted_address == this.input.customized.address);
    },

    value() {
      const retrievedValue = this.variable?.value;

      const applicableRetrievedValue = retrievedValue == null || isNaN(retrievedValue) ? 0 : retrievedValue;
      const applicableDecimalNumber = this.input?.customized?.decimals == null ? 2 : this.input.customized.decimals;

      return typeof applicableRetrievedValue === "boolean"
        ? applicableRetrievedValue
          ? this.input.customized.true_text
          : this.input.customized.false_text
        : applicableRetrievedValue > 1000
        ? Math.round(applicableRetrievedValue).toFixed(applicableDecimalNumber)
        : (Math.round(applicableRetrievedValue * 100) / 100).toFixed(applicableDecimalNumber);
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions("nodered", ["setShowingHistoryAddress"]),
  },

  watch: {
    showHistoryDialog(value) {
      this.setShowingHistoryAddress(value ? this.input.customized.address : "");
    },
  },
};
</script>

<style>
.KoioteValueLabel {
  font-size: 1vw;
}

@media (orientation: portrait) {
  .KoioteValueLabel {
    font-size: 1.3vw;
  }
}

@media (orientation: landscape) and (max-width: 600px) {
  .KoioteValueLabel {
    font-size: 0.85vw;
  }
}

@media (orientation: portrait) and (max-width: 500px) {
  .KoioteValueLabel {
    font-size: 1.55vw;
  }
}
</style>
